// Display names for a Sales Order's status — one list for every screen,
// kept in step with backend salesOrderStatusService.js's STATUS_VALUES.
// Draft, Submitted, Accepted, Picked, Packed and Shipped are the statuses on the
// lifecycle rules (Platform › Lifecycles, issue #277); the "Part …" values
// show an order whose lines are part-way to the next step.
export const SALES_ORDER_STATUS_LABELS = {
  draft: 'Draft',
  submitted: 'Submitted',
  processing: 'Accepted',
  partially_picked: 'Part Picked',
  picked: 'Picked',
  partially_packed: 'Part Packed',
  packed: 'Packed',
  partially_shipped: 'Part Shipped',
  shipped: 'Shipped',
};
